<div class="modal-header" appCustomAutofocus>
    <h3>
        <span *ngIf="type == 'finalize'">Finalize</span>
        <span *ngIf="type == 'submit'">Submit</span> {{where}}
    </h3>
</div>
<div class="modal-body" style="overflow-x: auto;" id="modal_size">
    <div *ngIf="signed">
        <p>
            Are you sure you want to
            <span *ngIf="type == 'finalize'">finalize</span>
            <span *ngIf="type == 'submit'">submit</span>
            your {{where.toLowerCase()}}?
        </p>
    </div>
    <div class="card border" [style.width.px]="465" style="margin-top:15px;" *ngIf="!signed">
        <div class="card-header bg-light">Please sign in the box below when you finish your {{where.toLowerCase()}}.</div>
        <div class="card-body" [style.width.px]="465" style="background-color:#d4d4d4;border:1px solid black;border-radius:5px;">
            <div class="alert alert-info" style="margin:10px;" *ngIf="showClickMsg">Press "Clear" before generating your signature image.</div>
            <div class="m-signature-pad">
                <div class="m-signature-pad--body" [ngClass]="{signaturepad: redBorder == true}"
                     *ngIf="!typeSign">
                    <signature-pad [options]="signaturePadOptions" #signaturePad></signature-pad>
                </div>
                <div *ngIf="submitSignImg != null" style="background-color:white;border:1px solid black">
                    <img [src]="submitSignImg" *ngIf="typeSign" style="max-width: 460px" />
                </div>
                <div class="m-signature-pad--footer">
                    <div style="text-align: center;font-size: 12px;">Sign above</div>
                    <button type="button" class="btn btn-outline-dark" (click)="clear()">Clear</button>
                    <button type="button" class="btn btn-outline-dark" (click)="getTypeSign('full')" *ngIf="enableCheckboxSign && !hideClick">Generate Signature</button>
                    <div class="alert alert-warning" style="margin:10px;">By signing above, I agree that the signature and initials will be the electronic representation of my signature and initials for all purposes when I (or my agent) use them on documents, including legally binding contracts - just the same as a pen-and-paper signature or initial.</div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="submitClicked()"><span *ngIf="type == 'finalize'">Finalize</span><span *ngIf="type == 'submit'">Submit</span></button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Close</button>
</div>